"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.search");
var _newLanding = require("@/api/decorate/newLanding");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'NewLandingTable',
  // 装修中心 - 上新落地页列表
  components: {},
  data: function data() {
    return {
      loading: false,
      tableKey: 0,
      tableData: [],
      total: 0,
      listQuery: {
        keywords: '',
        page: 1,
        limit: 10
      }
    };
  },
  created: function created() {
    this.search();
  },
  methods: {
    handleEdit: function handleEdit(item) {
      this.$emit('editActivity', item.id);
    },
    addActivity: function addActivity() {
      this.$emit('addActivity');
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.handleFilter();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.search();
    },
    search: function search() {
      this.listQuery.page = 1;
      this.handleFilter();
    },
    reset: function reset() {
      this.listQuery.keywords = '';
      this.listQuery.page = 1;
      this.handleFilter();
    },
    handleFilter: function handleFilter() {
      var _this = this;
      this.loading = true;
      (0, _newLanding.newLandingPage)(this.listQuery).then(function (res) {
        _this.tableData = res.records;
        _this.total = res.total;
        _this.loading = false;
      }, function () {
        _this.loading = false;
      });
    },
    /**
     * 切换活动状态
     */
    handleStatusChange: function handleStatusChange(row) {
      var _this2 = this;
      var statusText = row.status ? '启用' : '禁用';
      var loading = this.$loading({
        lock: true,
        text: "\u6B63\u5728".concat(statusText, "..."),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      (0, _newLanding.toggleNewLandingStatus)(row.id, row.status).then(function () {
        _this2.$message.success("".concat(statusText, "\u6210\u529F"));
        loading.close();
      }).catch(function () {
        // 失败时恢复原状态
        row.status = !row.status;
        loading.close();
      });
    },
    /**
     * 删除上新落地页
     */
    handleDelete: function handleDelete(row) {
      var _this3 = this;
      this.$confirm("\u786E\u5B9A\u5220\u9664\u6D3B\u52A8\u300C".concat(row.activityName, "\u300D\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.loading = true;
        (0, _newLanding.newLandingDelete)(row.id).then(function (res) {
          _this3.$message.success(res.message || '删除成功');
          _this3.handleFilter();
        }, function () {
          _this3.loading = false;
        });
      }).catch(function () {});
    },
    /**
     * 格式化日期（兼容时间戳和字符串）
     */
    formatDate: function formatDate(value) {
      if (!value) return '';
      var d = new Date(typeof value === 'number' ? value : String(value).replace(/-/g, '/'));
      if (isNaN(d.getTime())) return String(value);
      var y = d.getFullYear();
      var m = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      return "".concat(y, "-").concat(m, "-").concat(day);
    },
    /**
     * 格式化时间（兼容时间戳和字符串）
     */
    formatTime: function formatTime(value) {
      if (!value) return '';
      var d = new Date(typeof value === 'number' ? value : String(value).replace(/-/g, '/'));
      if (isNaN(d.getTime())) return String(value);
      var h = String(d.getHours()).padStart(2, '0');
      var m = String(d.getMinutes()).padStart(2, '0');
      return "".concat(h, ":").concat(m);
    }
  }
};